import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';

import { CmsService } from '../../../core/services/cms/cms.service';
import { LocaleDirective } from '../../directives/locale.directive';

@Component({
    selector: 'bog-label',
    imports: [NgClass, LocaleDirective],
    templateUrl: './bog-label.component.html',
    styleUrls: ['./bog-label.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DefaultBogLabelComponent implements OnInit {
    @Input() bogLabelStyle: boolean;
    isBogEnabled: boolean;
    @Input() isFromMyBets: boolean;
    @Input() isSettled: boolean;
    constructor(protected cmsService: CmsService) {}

    ngOnInit(): void {
        console.log('test is settled', this.isSettled);
        this.cmsService.isBogFromCms().subscribe((bog: boolean) => {
            return (this.isBogEnabled = bog);
        });
    }
}
